import { RegExpUtility } from "../../../library-js/text/RegExpUtility";
import { BinaryByteUnitConverter } from "../../../library-js/units/BinaryByteUnitConverter"
import { BinaryByteUnitPrefix } from "../../../library-js/units/BinaryByteUnitPrefix"
import { SIUnitConverter } from "../../../library-js/units/SIUnitConverter"
import { SIUnitPrefix } from "../../../library-js/units/SIUnitPrefix"
import { MathX } from "../../../library-js/math/MathX";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";

export class Result
{
  players = 0;
  relayed = 0;
  directlyConnected = 0;
  networkMultiply = 0;
  playerTraffic = 0;
  playerDownloadTraffic = 0;
  gameTraffic = 0;
  numGames = 0;
  hourTraffic = 0;
}


export function computeNetworkTraffic( element:Element )
{
  let getIntValue = ( name:string )=>
  {
    let attribute = new ElementAttribute( name );
    let attributeElement = attribute.query( element );

    if ( ElementType.input.is( attributeElement ) )
    {
      let input = attributeElement as HTMLInputElement;
      let value = parseInt( input.value );
      return Math.max( 0, value );
    }
    else ( ElementType.select.is( attributeElement ) )
    {
      let select = attributeElement as HTMLSelectElement;

      let values = 
      [
        0,
        28, 
        48,
        60,
        66, 
        80,
        86
      ]

      return values[ select.selectedIndex ];
    }

  }

  let result = new Result();


  let bytesPerPlayer = getIntValue( "bytes-per-player" ) + getIntValue( "overhead" );
  let sendingRate = getIntValue( "sending-rate" );
  let numPlayers = getIntValue( "num-players" );
  let directlyConnected = Math.min( getIntValue( "directly-connected" ), numPlayers );

  result.players = numPlayers;
  result.directlyConnected = directlyConnected;
  result.relayed = numPlayers - directlyConnected;
  result.playerTraffic = ( bytesPerPlayer * sendingRate * 8 ) / 1000;
  result.networkMultiply = numPlayers + result.relayed * ( numPlayers - 1 ) + directlyConnected * result.relayed;
  result.gameTraffic = result.networkMultiply * result.playerTraffic;
  result.numGames = 1000000 / result.gameTraffic; 
  result.hourTraffic = result.gameTraffic * 3.6;  

  result.playerDownloadTraffic = ( result.playerTraffic * ( numPlayers - 1 ) ).toFixed( 2 ) as any;
  result.playerTraffic = result.playerTraffic.toFixed( 2 ) as any;
  result.hourTraffic = result.hourTraffic.toFixed( 2 ) as any;
  result.gameTraffic = result.gameTraffic.toFixed( 2 ) as any;
  result.numGames = Math.floor( result.numGames ); 


  console.log( "NT", result );

  return result;
}